var components
try {
  components = {
    uSwiper: function () {
      return import(
        /* webpackChunkName: "uni_modules/uview-ui/components/u-swiper/u-swiper" */ "@/uni_modules/uview-ui/components/u-swiper/u-swiper.vue"
      )
    },
    uCell: function () {
      return import(
        /* webpackChunkName: "uni_modules/uview-ui/components/u-cell/u-cell" */ "@/uni_modules/uview-ui/components/u-cell/u-cell.vue"
      )
    },
    uLoadmore: function () {
      return import(
        /* webpackChunkName: "uni_modules/uview-ui/components/u-loadmore/u-loadmore" */ "@/uni_modules/uview-ui/components/u-loadmore/u-loadmore.vue"
      )
    },
    uEmpty: function () {
      return import(
        /* webpackChunkName: "uni_modules/uview-ui/components/u-empty/u-empty" */ "@/uni_modules/uview-ui/components/u-empty/u-empty.vue"
      )
    },
  }
} catch (e) {
  if (
    e.message.indexOf("Cannot find module") !== -1 &&
    e.message.indexOf(".vue") !== -1
  ) {
    console.error(e.message)
    console.error("1. 排查组件名称拼写是否正确")
    console.error(
      "2. 排查组件是否符合 easycom 规范，文档：https://uniapp.dcloud.net.cn/collocation/pages?id=easycom"
    )
    console.error(
      "3. 若组件不符合 easycom 规范，需手动引入，并在 components 中注册该组件"
    )
  } else {
    throw e
  }
}
var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  var g0 = _vm.indexList.length
  var l0 =
    g0 > 0
      ? _vm.__map(_vm.indexList, function (item, index) {
          var $orig = _vm.__get_orig(item)
          var g1 = _vm.$u.timeFormat(item.createTime, "yyyy-mm-dd hh:MM:ss")
          return {
            $orig: $orig,
            g1: g1,
          }
        })
      : null
  _vm.$mp.data = Object.assign(
    {},
    {
      $root: {
        g0: g0,
        l0: l0,
      },
    }
  )
}
var recyclableRender = false
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns, recyclableRender, components }